import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/Components/shadcn/dialog';
import { Button } from '@/Components/shadcn/button';
import UIStrings from '@/Utils/UIStrings';

interface ExitDialogProps {
    open: boolean;
    onCancel: () => void;
    onOk: () => void;
}

function ExitDialog({ onCancel, onOk, open }: ExitDialogProps): React.JSX.Element {
    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
            <DialogContent className="w-96 p-5">
                <DialogHeader>
                    <DialogTitle>{UIStrings.ExitWithUnsavedChanges}</DialogTitle>
                </DialogHeader>
                <DialogDescription>{UIStrings.ExitingNowWillDiscardAnyUnsavedChanges}</DialogDescription>
                <DialogFooter className="flex justify-center gap-2">
                    <Button variant="outline" onClick={onCancel}>
                        {UIStrings.ExitAndDiscard}
                    </Button>
                    <Button onClick={onOk}>{UIStrings.ContinueEditing}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default ExitDialog;
